export default __webpack_public_path__ + "static/media/map.2c113404.svg";